import React from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../components/styled";

// Confirmation modal that fires from the listing when the user clicks
// the inline Delete CTA on a DRAFT change request row. Confirm fires
// the CANCEL action and the parent refetches the list on success.
export default function CancelChangeRequestModal({
  open,
  onClose,
  onConfirm,
  cancelling,
  actionLabel = "Delete",
}) {
  const safeClose = () => {
    if (cancelling) return;
    onClose?.();
  };
  return (
    <Dialog
      open={open}
      onClose={safeClose}
      PaperProps={{
        sx: { borderRadius: "12px", width: "min(440px, 92vw)" },
      }}
    >
      <Box sx={{ padding: "20px 24px 8px" }}>
        <Box
          component="p"
          sx={{
            margin: 0,
            fontSize: 18,
            fontWeight: 600,
            color: "#0D0D0E",
            fontFamily: "Inter Tight",
          }}
        >
          {actionLabel} Change Request?
        </Box>
      </Box>
      <DialogContent sx={{ pt: 1 }}>
        <Typography
          sx={{
            fontSize: 14,
            color: "#4B5563",
            fontFamily: "Inter Tight",
          }}
        >
          Are you sure you want to delete the change request?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 2.5,
          pt: 1,
          display: "flex",
          gap: 2,
          justifyContent: "space-between",
        }}
      >
        <SecondaryButton onClick={safeClose} disabled={cancelling}>
          Cancel
        </SecondaryButton>
        <PrimaryButton onClick={onConfirm} disabled={cancelling}>
          {cancelling ? "Deleting..." : actionLabel}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
